import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { SparkleFrameIcon } from '@/icons';
import { Button, type ButtonProps, DialogTrigger } from '@/ui_v3';
export const DesktopTrigger = (props: ButtonProps) => {
  const {
    t
  } = useTranslation(['build']);
  return <DialogTrigger asChild data-sentry-element="DialogTrigger" data-sentry-component="DesktopTrigger" data-sentry-source-file="DesktopTrigger.tsx">
      <Button size="xs" className="hidden mobile-lg:flex" onMouseDown={e => e.preventDefault()} onClick={props.onClick} leftSlot={<SparkleFrameIcon size="xs" fill={props.disabled ? ICON_COLOR.neutral : ICON_COLOR.default} opacity={props.disabled ? 0.54 : 1} />} variant="outlined" intent="neutral" disabled={props.disabled} data-sentry-element="Button" data-sentry-source-file="DesktopTrigger.tsx">
        {t('build:ai.similarQuiz.button')}
      </Button>
    </DialogTrigger>;
};